/**
 * Luxury monochrome stat card — sharp corners, hairline border,
 * oversized serif numeral, mono uppercase label.
 */
export default function StatCard({ label, value, icon: Icon, highlight }) {
  const isAlert = highlight && value > 0;
  return (
    <div
      className={`border-r border-b border-stone-200 p-6 md:p-7 transition-colors ${
        isAlert ? "bg-stone-900 text-stone-50" : "bg-white hover:bg-stone-50"
      }`}
      data-testid={`stat-card-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className={`flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.22em] ${
        isAlert ? "text-stone-300" : "text-stone-500"
      }`}>
        <Icon className="h-3 w-3" />
        {label}
      </div>
      <div className={`font-serif font-light text-4xl md:text-5xl mt-4 leading-none tracking-tight ${
        isAlert ? "text-stone-50" : "text-stone-900"
      }`}>
        {value}
      </div>
    </div>
  );
}
